import { useCallback, useEffect } from "react";
import { endpoints } from "../../config";
import useStaticRequest from "./useStaticRequest";

const useStaticJsonRequest = (jsonRelativePath) => {
  const [{ data, error, loading }, performRequest] = useStaticRequest(
    endpoints.getJsonEndPoint(jsonRelativePath)
  );

  const refresh = useCallback(() => {
    return performRequest();
  }, [performRequest]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, error, loading, refresh };
};

export default useStaticJsonRequest;
